import React from "react";
import { docsColors } from "@/lib/docs-theme";

interface DocTitleProps {
  title: string;
  description?: string;
}

export default function DocTitle({ title, description }: DocTitleProps) {
  return (
    <>
      <h1 className={`text-4xl font-bold ${docsColors.text.heading} mb-4`}>{title}</h1>
      {description && <p className={`text-xl ${docsColors.text.body} mb-8`}>{description}</p>}
    </>
  );
}
